// extracted by mini-css-extract-plugin
export default {"Container":"SignedInHome_Container__6Hx8k","Page":"SignedInHome_Page__doqrP"};